export default __webpack_public_path__ + "static/media/edit_ic.a541fcc3.svg";